export class PlatformJwtManager {
    constructor(tokenStorage, userInfo, tokenValidator, requestGateway) {
        this.tokenStorage = tokenStorage;
        this.userInfo = userInfo;
        this.tokenValidator = tokenValidator;
        this.requestGateway = requestGateway;
    }
    getPlatformJWT() {
        const token = this.tokenStorage.getToken();
        if (!token) {
            this.userInfo.logout();
        }
        return token;
    }
    setPlatformJWT(token) {
        if (token) {
            this.requestGateway.setToken(token);
        }
    }
    hasLoggedInToken() {
        const token = this.tokenStorage.getToken();
        return token && !this.tokenValidator.isAnonymous(token);
    }
}
//# sourceMappingURL=PlatformJwtManager.js.map